import { render, staticRenderFns } from "./statis.vue?vue&type=template&id=4a19745b&scoped=true"
import script from "./statis.vue?vue&type=script&lang=js"
export * from "./statis.vue?vue&type=script&lang=js"
import style0 from "./statis.vue?vue&type=style&index=0&id=4a19745b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a19745b",
  null
  
)

export default component.exports